import { createApi } from '@reduxjs/toolkit/query/react';
import { createBaseQuery, toQueryParams } from 'helpers/api';

export const employeesApi = createApi({
  reducerPath: 'employeesApi',
  baseQuery: createBaseQuery('employees', { timeout: 200000 }),
  endpoints: builder => ({
    getEmployee: builder.query({
      query: id => `/${id}`,
      transformResponse: ({ result }) => result,
    }),
    getEmployees: builder.query({
      query: ({ params }) => `?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    createEmployee: builder.mutation({
      query: data => ({
        url: '',
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    configureEmployee: builder.mutation({
      query: id => ({
        url: `/${id}/configure`,
        method: 'POST',
      }),
      transformResponse: ({ result }) => result,
    }),
    getEmployeesResults: builder.query({
      query: ({ params }) => `results?${toQueryParams(params)}`,
      transformResponse: ({ result }) => result,
    }),
    bulkAddCheckRenewalsToEmployees: builder.mutation({
      query: ({ employee_ids, use_all, renewal_checks }) => ({
        url: '/bulk/add_renewals',
        method: 'POST',
        body: { employee_ids, use_all, renewal_checks },
      }),
      transformResponse: ({ result }) => result,
    }),
    updateEmployee: builder.mutation({
      query: ({ id, data }) => ({
        url: `/${id}`,
        method: 'PUT',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    deleteEmployee: builder.mutation({
      query: id => ({
        url: `/${id}`,
        method: 'DELETE',
      }),
      transformResponse: ({ result }) => result,
    }),
    getRenewalConsentCheckTypesByToken: builder.query({
      query: token => `/token/${token}/consent_check_types`,
      transformResponse: ({ result }) => result,
    }),
    submitRenewalConsentByToken: builder.mutation({
      query: ({ token, data }) => ({
        url: `/token/${token}/renewal_consent`,
        method: 'POST',
        body: data,
      }),
      transformResponse: ({ result }) => result,
    }),
    declineRenewalConsentByToken: builder.mutation({
      query: token => ({
        url: `/token/${token}/renewal_consent_decline`,
        method: 'POST',
      }),
      transformResponse: ({ result }) => result,
    }),
  }),
});

export const {
  useLazyGetEmployeesQuery,
  useGetEmployeeQuery,
  useCreateEmployeeMutation,
  useLazyGetEmployeesResultsQuery,
  useUpdateEmployeeMutation,
  useDeleteEmployeeMutation,
  useBulkAddCheckRenewalsToEmployeesMutation,
  useConfigureEmployeeMutation,
  useGetRenewalConsentCheckTypesByTokenQuery,
  useSubmitRenewalConsentByTokenMutation,
  useDeclineRenewalConsentByTokenMutation,
} = employeesApi;
